/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from '../cart.component.scss.shim.ngstyle';
import * as i1 from '@angular/core';
import * as i2 from '@ngx-translate/core/src/translate.pipe';
import * as i3 from '@ngx-translate/core/src/translate.service';
import * as i4 from '@angular/common';
import * as i5 from '../../../../app/cart/proceed-to-payment-button/cart.proceed-to-payment-button.component';
import * as i6 from '@angular/router';
import * as i7 from '../../../../app/cart/services/cart-rows-updater.service';
const styles_CartProceedToPaymentButtonComponent:any[] = [i0.styles];
export const RenderType_CartProceedToPaymentButtonComponent:i1.RendererType2 = i1.ɵcrt({encapsulation:0,
    styles:styles_CartProceedToPaymentButtonComponent,data:{}});
function View_CartProceedToPaymentButtonComponent_1(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),4,'button',[['class',
      'btn btn-success btn-block btn-md float-right']],(null as any),[[(null as any),
      'click']],(_v,en,$event) => {
    var ad:boolean = true;
    var _co:any = _v.component;
    if (('click' === en)) {
      const pd_0:any = ((<any>_co.proceedToPayment()) !== false);
      ad = (pd_0 && ad);
    }
    return ad;
  },(null as any),(null as any))),(_l()(),i1.ɵted(1,(null as any),['\n    ','\n    '])),
      i1.ɵpid(131072,i2.TranslatePipe,[i3.TranslateService,i1.ChangeDetectorRef]),
      (_l()(),i1.ɵeld(3,0,(null as any),(null as any),0,'span',[['class','fa fa-lock ml-xs']],
          (null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i1.ɵted(-1,(null as any),['\n']))],(null as any),(_ck,_v) => {
    const currVal_0:any = i1.ɵunv(_v,1,0,i1.ɵnov(_v,2).transform('CART.RESUME.PROCEED_TO_PAYMENT_BUTTON'));
    _ck(_v,1,0,currVal_0);
  });
}
export function View_CartProceedToPaymentButtonComponent_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵand(16777216,(null as any),(null as any),1,(null as any),
      View_CartProceedToPaymentButtonComponent_1)),i1.ɵdid(1,16384,(null as any),0,
      i4.NgIf,[i1.ViewContainerRef,i1.TemplateRef],{ngIf:[0,'ngIf']},(null as any)),
      (_l()(),i1.ɵted(-1,(null as any),['\n']))],(_ck,_v) => {
    var _co:i5.CartProceedToPaymentButtonComponent = _v.component;
    const currVal_0:any = _co.canProceedToPayment();
    _ck(_v,1,0,currVal_0);
  },(null as any));
}
export function View_CartProceedToPaymentButtonComponent_Host_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),1,'cart-proceed-to-payment-button',
      ([] as any[]),(null as any),(null as any),(null as any),View_CartProceedToPaymentButtonComponent_0,
      RenderType_CartProceedToPaymentButtonComponent)),i1.ɵdid(1,49152,(null as any),
      0,i5.CartProceedToPaymentButtonComponent,[i6.Router,i7.CartRowsUpdaterService,
          i1.NgZone],(null as any),(null as any))],(null as any),(null as any));
}
export const CartProceedToPaymentButtonComponentNgFactory:i1.ComponentFactory<i5.CartProceedToPaymentButtonComponent> = i1.ɵccf('cart-proceed-to-payment-button',
    i5.CartProceedToPaymentButtonComponent,View_CartProceedToPaymentButtonComponent_Host_0,
    {},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL2NvZGVidWlsZC9vdXRwdXQvc3JjMjAzMjkyODc1MC9zcmMvc3JjL2FwcC9jYXJ0L3Byb2NlZWQtdG8tcGF5bWVudC1idXR0b24vY2FydC5wcm9jZWVkLXRvLXBheW1lbnQtYnV0dG9uLmNvbXBvbmVudC5uZ2ZhY3RvcnkudHMiLCJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJuZzovLy9jb2RlYnVpbGQvb3V0cHV0L3NyYzIwMzI5Mjg3NTAvc3JjL3NyYy9hcHAvY2FydC9wcm9jZWVkLXRvLXBheW1lbnQtYnV0dG9uL2NhcnQucHJvY2VlZC10by1wYXltZW50LWJ1dHRvbi5jb21wb25lbnQudHMiLCJuZzovLy9jb2RlYnVpbGQvb3V0cHV0L3NyYzIwMzI5Mjg3NTAvc3JjL3NyYy9hcHAvY2FydC9wcm9jZWVkLXRvLXBheW1lbnQtYnV0dG9uL2NhcnQucHJvY2VlZC10by1wYXltZW50LWJ1dHRvbi5jb21wb25lbnQuaHRtbCIsIm5nOi8vL2NvZGVidWlsZC9vdXRwdXQvc3JjMjAzMjkyODc1MC9zcmMvc3JjL2FwcC9jYXJ0L3Byb2NlZWQtdG8tcGF5bWVudC1idXR0b24vY2FydC5wcm9jZWVkLXRvLXBheW1lbnQtYnV0dG9uLmNvbXBvbmVudC50cy5DYXJ0UHJvY2VlZFRvUGF5bWVudEJ1dHRvbkNvbXBvbmVudF9Ib3N0Lmh0bWwiXSwic291cmNlc0NvbnRlbnQiOlsiICIsIjxidXR0b24gY2xhc3M9XCJidG4gYnRuLXN1Y2Nlc3MgYnRuLWJsb2NrIGJ0bi1tZCBmbG9hdC1yaWdodFwiXG4gICAgICAgICpuZ0lmPVwiY2FuUHJvY2VlZFRvUGF5bWVudCgpXCJcbiAgICAgICAgKGNsaWNrKT1cInByb2NlZWRUb1BheW1lbnQoKVwiPlxuICAgIHt7XCJDQVJULlJFU1VNRS5QUk9DRUVEX1RPX1BBWU1FTlRfQlVUVE9OXCIgfCB0cmFuc2xhdGV9fVxuICAgIDxzcGFuIGNsYXNzPVwiZmEgZmEtbG9jayBtbC14c1wiPjwvc3Bhbj5cbjwvYnV0dG9uPlxuIiwiPGNhcnQtcHJvY2VlZC10by1wYXltZW50LWJ1dHRvbj48L2NhcnQtcHJvY2VlZC10by1wYXltZW50LWJ1dHRvbj4iXSwibWFwcGluZ3MiOiJBQUFBOzs7Ozs7Ozs7Ozs7Ozs7Ozs7OztvQkNBQTtNQUFBO01BQUE7SUFBQTtJQUFBO0lBRVE7TUFBQTtNQUFBO0lBQUE7SUFGUjtFQUFBLGdDQUVxQzthQUFBO01BRWpDO1VBQUE7TUFBc0M7SUFGTDtJQUFBOzs7O29CQUZyQztNQUFBLG9EQUFBO2NBQUE7TUFLUzs7SUFKRDtJQURSLFdBQ1EsU0FEUjs7OztvQkNBQTtNQUFBO29EQUFBLFVBQUE7TUFBQTttQkFBQTs7OzsifQ==



// WEBPACK FOOTER //
// /codebuild/output/src2032928750/src/src/$$_gendir/app/cart/proceed-to-payment-button/cart.proceed-to-payment-button.component.ngfactory.ts